import { MOST_ACTIVE_BY_VOLUME, MOST_ACTIVE_BY_VOLUME_STREAM, MOST_VOLUME_LAST_UPDATED_TIME, } from "../../../interface/DrivingMarket/iMostActiveByVolume";
import { drivingMarketStream } from "@domains/features/Markets/Futures/utils/streamingUpdate";
let initState = {
    mostActiveByVolumeList: [],
    latestUpdatedTime: "",
};
const mostActiveByVolumeReducer = (state = initState, action) => {
    var _a;
    switch (action.type) {
        case MOST_ACTIVE_BY_VOLUME:
            return Object.assign(Object.assign({}, state), { mostActiveByVolumeList: action.payload.mostActiveByVolumeList });
        case MOST_ACTIVE_BY_VOLUME_STREAM:
            return Object.assign(Object.assign({}, state), { mostActiveByVolumeList: drivingMarketStream(state.mostActiveByVolumeList, action.payload.qouteStream), latestUpdatedTime: (_a = action.payload.qouteStream) === null || _a === void 0 ? void 0 : _a.updatedTime });
        case MOST_VOLUME_LAST_UPDATED_TIME:
            return Object.assign(Object.assign({}, state), { latestUpdatedTime: action.payload.latestUpdatedTime });
        default:
            return state;
    }
};
export default mostActiveByVolumeReducer;
